import { hoistStatics, setDisplayName } from 'recompose';

export default name => {
  return hoistStatics(setDisplayName(name));
};
